module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.11533/assets/images/g2-banner.png"